var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 36.849,
    viewBox: "0 0 30 36.849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "apple",
    d: "M24.276,7.877A8.069,8.069,0,0,0,26.229,2,8.18,8.18,0,0,0,20.7,4.8a7.683,7.683,0,0,0-1.842,5.693,6.8,6.8,0,0,0,5.416-2.616Zm4.643,13.707A8.309,8.309,0,0,1,32.9,14.565a8.585,8.585,0,0,0-6.743-3.685c-2.874-.295-5.527,1.677-7.056,1.677s-3.685-1.64-6.08-1.6a9.064,9.064,0,0,0-7.627,4.661c-3.243,5.638-.829,14.02,2.413,18.571,1.474,2.229,3.316,4.753,5.748,4.661s3.224-1.511,6.043-1.511,3.685,1.511,6.08,1.455,4.09-2.284,5.638-4.514a20.266,20.266,0,0,0,2.542-5.251,8.125,8.125,0,0,1-4.937-7.443Z",
    transform: "translate(-3.856 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApple);
export default __webpack_public_path__ + "static/media/icon_apple.33c0c2c5e1e29a0af73765c64de1c681.svg";
export { ForwardRef as ReactComponent };